"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLASS_MASK_TEXT_NO_MARGIN = exports.CLASS_MASK_TEXT = exports.CLASS_FILLED = exports.CLASS_FADING_OUT = exports.CLASS_FADING_IN = exports.CLASS_FOOTER_MODAL__CONTENT = exports.CLASS_FADABLE = exports.CLASS_FADE = exports.CLASS_NAV_OPEN = exports.CLASS_DNONE = exports.CLASS_ACTIVE = exports.CLASS_STICKY = exports.CLASS_HIDDEN = exports.CLASS_OPEN = void 0;
exports.CLASS_OPEN = 'is-open';
exports.CLASS_HIDDEN = 'is-hidden';
exports.CLASS_STICKY = 'is-sticky';
exports.CLASS_ACTIVE = 'is-active';
exports.CLASS_DNONE = 'd-none';
exports.CLASS_NAV_OPEN = 'nav-open';
exports.CLASS_FADE = 'fade-in';
exports.CLASS_FADABLE = 'is-fadable';
exports.CLASS_FOOTER_MODAL__CONTENT = 'footer__modal__content';
exports.CLASS_FADING_IN = 'is-fading--in';
exports.CLASS_FADING_OUT = 'is-fading--out';
exports.CLASS_FILLED = 'is-filled';
exports.CLASS_MASK_TEXT = 'mask-text-only';
exports.CLASS_MASK_TEXT_NO_MARGIN = 'mask-text-only--no-margin';
